import { assetsApi } from "../adapters";
import { useEnhancedMutation } from "./useEnhancedMutation";
import { AssetRequest } from "@telegraphio/bapi-types";

export function useGetAssetHistory() {
  return useEnhancedMutation({
    mutationFn: async ({
      customerId,
      equipmentId,
      requestData,
    }: {
      customerId: string;
      equipmentId: string;
      requestData: AssetRequest;
    }) => {
      const data = await assetsApi.getAssetHistory(customerId, equipmentId, requestData);

      return data;
    },
    notifications: {
      loading: { message: "Loading equipment history" },
      error: { message: "Unable to load history" },
    },
  });
}
